export interface RelatedEntityInterface {
  entityId?: number;
  entityType?: string;
}

export class RelatedEntity implements RelatedEntityInterface {
  public entityId?: number;
  public entityType?: string;

  constructor({
    entityId = undefined,
    entityType = undefined,
    }: RelatedEntityInterface) {
    this.entityId = entityId;
    this.entityType = entityType;
  }
}
